import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import dueImage from "./due.png";

const TymTblCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // ⏳ demo loading – API असल्यास तिथे setLoading(false) कर
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const styles = {
    card: {
      width: "270px",
      height: "185px",
      borderRadius: "22px",
     background:
  "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
boxShadow: "0 30px 70px #063552",

      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "#fff",
      cursor: loading ? "default" : "pointer",
      transition: "all 0.35s ease",
    },

    img: {
      width: "42px",
      marginBottom: "10px",
    },

    title: {
      fontSize: "18px",
      fontWeight: 800,
      marginTop: "6px",
    },

    sub: {
      fontSize: "13px",
      opacity: 0.9,
      marginTop: "6px",
      fontWeight: 600,
    },
  };

  return (
   <div
  style={styles.card}
  onClick={() => {
    if (!loading) navigate("/Timetable");
  }}
  onMouseEnter={(e) => {
    if (!loading) {
      e.currentTarget.style.transform = "translateY(-6px)";
      e.currentTarget.style.boxShadow =
        "0 35px 80px #063552";
    }
  }}
  onMouseLeave={(e) => {
    if (!loading) {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow =
        "0 30px 70px #063552";
    }
  }}
>

      {/* ===== LOADING STATE (Subjects-style) ===== */}
      {loading && (
        <>
          <CircularProgress sx={{ color: "#fff", mb: 1.5 }} />
          <div style={styles.sub}>Loading Timetable...</div>
        </>
      )}

      {/* ===== NORMAL STATE ===== */}
      {!loading && (
        <>
          <img src={dueImage} alt="Time Table" style={styles.img} />
          <div style={styles.title}>Time Table</div>
          <div style={styles.sub}>Click to view details</div>
        </>
      )}
    </div>
  );
};

export default TymTblCard;
